const currentMode = import.meta.env.MODE || "development";
const appEnv = import.meta.env.VITE_APP_ENV || currentMode;

export const ENV = {
  // Environment Information
  MODE: currentMode,
  APP_ENV: appEnv,
  IS_DEV: currentMode === "development" || appEnv === "development",
  IS_STAGING: currentMode === "staging" || appEnv === "staging",
  IS_PROD: currentMode === "production" || appEnv === "production",

  APP_NAME: import.meta.env.VITE_APP_NAME || "DRC ResumeHub",
  COMPANY_NAME: import.meta.env.VITE_COMPANY_NAME || "DRC Systems",
  COMPANY_LOGO:
    import.meta.env.VITE_COMPANY_LOGO ||
    "https://www.drcsystems.com/wp-content/themes/drc2026/assets/images/logo.svg",
  PRIMARY_COLOR: import.meta.env.VITE_PRIMARY_COLOR || "#4338CA",
  SECONDARY_COLOR: import.meta.env.VITE_SECONDARY_COLOR || "#06B6D4",
  DEFAULT_THEME: import.meta.env.VITE_DEFAULT_THEME || "system",
  DEFAULT_LANGUAGE: import.meta.env.VITE_DEFAULT_LANGUAGE || "en",
  BASE_URL:
    import.meta.env.VITE_BASE_URL || "http://192.168.24.48.nip.io:8000",
  ENABLE_AI: import.meta.env.VITE_ENABLE_AI === "true",
  ENABLE_REPORTS: import.meta.env.VITE_ENABLE_REPORTS === "true",
  ENABLE_NOTIFICATIONS: import.meta.env.VITE_ENABLE_NOTIFICATIONS === "true",
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === "true",
  ENABLE_EXPORT: import.meta.env.VITE_ENABLE_EXPORT === "true",
  ENABLE_IMPORT: import.meta.env.VITE_ENABLE_IMPORT === "true",
  ENABLE_SEARCH: import.meta.env.VITE_ENABLE_SEARCH === "true",
  ROWS_PER_PAGE: Number(import.meta.env.VITE_ROWS_PER_PAGE) || 10,
  DATE_FORMAT: import.meta.env.VITE_DATE_FORMAT || "MMM DD, YYYY",
  TIME_FORMAT: import.meta.env.VITE_TIME_FORMAT || "hh:mm A",

  // Employee Portal Auth Configurations
  EMPLOYEE_PORTAL_URL:
    import.meta.env.VITE_EMPLOYEE_PORTAL_URL ||
    "http://localhost:5173/employee",
  EMPLOYEE_AUTH_ENABLED:
    import.meta.env.VITE_EMPLOYEE_AUTH_ENABLED !== "false", // Default to true
  SSO_ENABLED: import.meta.env.VITE_SSO_ENABLED !== "false", // Default to true
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || "",
  GOOGLE_CLIENT_SECRET: import.meta.env.VITE_GOOGLE_CLIENT_SECRET || "",
  MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID || "",
  MICROSOFT_CLIENT_SECRET: import.meta.env.VITE_MICROSOFT_CLIENT_SECRET || "",
  SESSION_SECRET: import.meta.env.VITE_SESSION_SECRET || "default-session-secret",
  JWT_SECRET: import.meta.env.VITE_JWT_SECRET || "default-jwt-secret",
  JWT_EXPIRATION: import.meta.env.VITE_JWT_EXPIRATION || "24h",
  REFRESH_TOKEN_EXPIRATION:
    import.meta.env.VITE_REFRESH_TOKEN_EXPIRATION || "7d",
};
